declare let window: OldUIContext.TenForceWindow

export const getWorkspaceId = window.env.getWorkspaceId
